import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { ReserveCompleteFragmentComponent } from './ReserveCompleteFragmentComponent';
import {StorageService} from '../../../../../../../Service/StorageService';
import {AppSingletonUtil} from '../../../../../../../Util/AppSingletonUtil';
import {UserService} from '../../../../../../../Service/UserService';
import {ReserveService} from '../../../../../../../Service/ReserveService';
import {AuthService} from '../../../../../../../Service/AuthService';
import {PostCodeService} from '../../../../../../../Service/PostCodeService';
import {UserDTOInterface} from '../../../../../../../DTO/UserDTOInterface';

/**
 * ReserveCompleteFragmentController
 * 問診画面のコントローラー
 */
export class ReserveCompleteFragmentController extends BaseFragmentController {

	// 対となるView
	public combineView: ReserveCompleteFragmentComponent;


	/**
	 * ログイン済みでトークンを設定しているかどうか
	 * @returns true: トークン・ユーザー情報あり/false: トークン無し or ユーザー情報無し
	 */
	public async isExistToken(view: any) {

		// ストレージにトークンがあるかチェック
		const svc = new StorageService(this);
		const isExist = await svc.isItemExist('t');

		// トークンが存在しなければログアウト
		if (!isExist) {
			return false;
		}
		// トークンを取得
		const token = await svc.getItem('t');
		if (!token) {
			// トークンの値が存在しない場合
			await svc.clear();
			return false;
		}
		AppSingletonUtil.setToken(token);

		// ユーザー情報を取得
		// トークンでユーザー情報が取得できるかどうか
		const userSvc = new UserService(view);
		const user = await userSvc.getUserInfo();
		if (!user) {
			// ユーザー情報取れない場合は終了
			await svc.clear();
			return false;
		}
		AppSingletonUtil.setUserInfo(user);

		return true;
	}

	/**
	 *
	 * @param param
	 */
	public async getUserInfo(param: { view: any }) {

		const svc = new UserService(param.view);
		const ret = await svc.getUserInfo();

		return ret;

	}

	/**
	 * 予約完了メッセージの送信
	 * @param param
	 */
	public async sendReserveCompleteMessage(param: {view: any; reserveId: number}): Promise<any> {
		const svc = new ReserveService(param.view);
		const ret = await svc.sendReserveCompleteMessage(param.reserveId);

		return ret;
	}


	/**
	 * 予約トークンとリファラの削除
	 * @param param
	 */
	public async deleteTokenAndRef(param: {view: any}): Promise<any> {

		// ストレージにトークンがあるかチェック
		const svc = new StorageService(this);
		let isExist = await svc.isItemExist('reserveToken');
		if (isExist === false) {
			return;
		}

		await svc.delete('reserveToken');

		isExist = await svc.isItemExist('referrer');

		if (isExist === false) {
			return;
		}
		await svc.delete('referrer');

		return;
	}

	/**
	 * LINEとの連携状態を取得する
	 */
	public async getLineLinkStatus(param: {view: any}) {

		const svc = new UserService(param.view);
		const ret = await svc.getLineLinkStatus();

		return ret;

	}

	/**
	 * stateを生成
	 * @returns string
	 */
	public async getState() {
		return this.generateRandomId(32);
	}
	/**
	 * nonceを生成
	 * @returns string
	 */
	public async getNonce() {
		return this.generateRandomId(8);
	}


	/**
	 * 認可リクエスト記録
	 */
	public async recordAuth(loginUrl: string, stateString: string, nonceString: string) {
		const svc = new AuthService(this);
		return await svc.lineLoginRecordAuth(loginUrl, stateString, nonceString);
	}

	/**
	 * ブラウザにstateとnonceを保存
	 */
	public async setStateNonce(param: { stateString: string; nonceString: string }) {
		const svc = new StorageService(this);
		await svc.saveItem('state', param.stateString);
		await svc.saveItem('nonce', param.nonceString);
		return;
	}

	/**
	 * ランダム文字生成
	 * @returns string
	 * @param length
	 */
	private generateRandomId(length: number): string {
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let result = '';

		for (let i = 0; i < length; i++) {
			const randomIndex = Math.floor(Math.random() * characters.length);
			result += characters.charAt(randomIndex);
		}
		return result;
	};

	/**
	 * getConfigForClient
	 * Lineログインの設定情報を取得
	 * @returns any
	 */
	public getConfigForClient() {
		const svc = new AuthService(this);
		return svc.getConfigForClient();
	}


	/**
	 * オンライン診療に必要なユーザー情報の更新
	 * @param param
	 */
	public async updateOnlineMedicalData(param: { view: any; data: { user: UserDTOInterface } }) {
		const svc = new UserService(param.view);
		return await svc.updateOnlineMedicalData(param.data.user);
	}


	/**
	 * 郵便番号から住所を自動入力
	 * @param param
	 */
	public async getAddress(param: { view: any; postCode: string }): Promise<{prefecture: string; city: string}> {

		const svc = new PostCodeService(param.view);
		return await svc.getAddress(param.postCode);

	}
}
